import gql from 'graphql-tag'

export const ADD_PAGE_VISITED = gql`
mutation AddPageVisitedMutation (
  $patientID: String
  $time: String
  $page: String
  $siteType: String
) {
  addPageVisited(
    patientID: $patientID
    time: $time
    page: $page
    siteType: $siteType
  )
}
`



// WEBPACK FOOTER //
// ./src/mutations/ADD_PAGE_VISITED.ts